/**
 * ------------------------------
 * DOMAIN INFO
 * ------------------------------
 */

import { DomainInfo, Menu } from "./domainInfo";
export type { DomainInfo, Menu };
export { getDomainInfo } from "./domainInfo";

/**
 * ------------------------------
 * MENUS
 * ------------------------------
 */

export { getMenus } from "./menus";

/**
 * ------------------------------
 * DOMAIN POSTS
 * ------------------------------
 */

export { getDomainPosts } from "./fetchDomainPosts";

/**
 * ------------------------------
 * DOMAIN POPUP
 * ------------------------------
 */

import { DomainPopup } from "./domainPopup";
export type { DomainPopup };
export { getDomainPopup } from "./domainPopup";

/**
 * ------------------------------
 * DOMAIN FORM
 * ------------------------------
 */

import { DomainForm } from "./domainForm";
export type { DomainForm };
export { getDomainForm } from "./domainForm";

/**
 * ------------------------------
 * SESSION
 * ------------------------------
 */

import type { Session, VisitDetails } from "./session";
export type { Session, VisitDetails };
// NOTE: getUserSession is intentionally NOT re-exported here. It pulls in
// server-only request signing (Node "crypto"). Import it directly from
// "src/api/session" in server-only code to keep it out of client bundles.

/**
 * ------------------------------
 * LISTING
 * ------------------------------
 */
import { Listing, ComparisonListing } from "./listings";
export type { Listing, ComparisonListing };
export {
    getComparisonListing,
    getListingBySlug,
    getListingBySlugV3,
} from "./listings";

/**
 * ------------------------------
 * ROUTES
 * ------------------------------
 */

import { GenericRoutes, Route } from "./routes";
export type { GenericRoutes, Route };
export { postNotFoundPage, getGenericRoutes } from "./routes";

/**
 * ------------------------------
 * DKIS
 * ------------------------------
 */

import { DKI } from "./dkis";
export type { DKI };
export { getDKIs } from "./dkis";

/**
 * ------------------------------
 * LOOKUPS
 * ------------------------------
 */

import { ZipCodeLocation } from "./lookup";
export type { ZipCodeLocation };
export { getLocationByZipCode } from "./lookup";

/**
 * ------------------------------
 * SEARCH
 * ------------------------------
 */

import { ZipCodeSearch } from "./zipCodeSuggestions";
export type { ZipCodeSearch };
export { getZipCodeSuggestions } from "./zipCodeSuggestions";

/**
 * ------------------------------
 * DYNAMIC LOOKUPS AND VARIATIONS
 * ------------------------------
 */

// import { ZipCodeLocation } from "./lookupsAndVariations";
// export type { ZipCodeLocation };
export { getLookupsAndVariations } from "./lookupsAndVariations";

/**
 * ------------------------------
 * CLICKS
 * ------------------------------
 */

import { ClicksSearchList } from "./clicks";
export type { ClicksSearchList };
export { getClickLink, getClicksSearchList } from "./clicks";

/**
 * ------------------------------
 * CLICKS
 * ------------------------------
 */

import { ValidationResponse, ValidationBody } from "./validation";
export type { ValidationResponse, ValidationBody };
export { validateField } from "./validation";

/**
 * ------------------------------
 * CONTACT US
 * ------------------------------
 */
import { ContactUsFormResponse } from "./contactUs";
export type { ContactUsFormResponse };
export { submitContactUsForm } from "./contactUs";

import { DoNotSellFormResponse } from "./doNotSell";
export type { DoNotSellFormResponse };
export { submitDoNotSellForm } from "./doNotSell";

export { submitLeadForm } from "./submitLead";

export { getOfferUrl } from "./offers";

export { getAliasUrl } from "./aliasUrl";

/**
 * ------------------------------
 * Blog Post
 * ------------------------------
 */

export { getBlog } from "./getBlog";

/**
 * ------------------------------
 * call event
 * ------------------------------
 */

export { callEvent } from "./callEvent";
/**
 * ------------------------------
 * call event
 * ------------------------------
 */

export { getRouteConfig } from "./routeConfig";

/**
 * ------------------------------
 * Pii Completion
 * ------------------------------
 */

export { getPiiCompletion } from "./piiCompletion";
export { LogVisitDetails } from "./accessLog";
